<!-- Card (same shape as the ICP score header) -->
<div *ngIf="state.enabled === true" id="sql-qualification-card" class="rounded-xl p-2 2xl:p-3 h-full w-full"
     [ngClass]="{
        'bg-icp-low/5': hasScore && tierClass === 'low',
        'bg-icp-medium/5': hasScore && tierClass === 'medium',
        'bg-icp-high/5': hasScore && tierClass === 'high',
        'bg-violet-50/50 dark:bg-secondary-800': !hasScore
     }">
  <div class="flex justify-start items-center min-h-[3rem]">

    <div class="flex shrink-0 justify-center items-center rounded-lg text-center h-12 w-12 2xl:w-20 !shadow-md"
         [ngClass]="{
            'bg-icp-low !shadow-icp-low/25': hasScore && tierClass === 'low',
            'bg-icp-medium !shadow-icp-medium/25': hasScore && tierClass === 'medium',
            'bg-icp-high !shadow-icp-high/25': hasScore && tierClass === 'high',
            'bg-gray-300 dark:bg-secondary-700 animate-pulse': isRunning,
            'bg-[#802cfa]': !hasScore && !isRunning
         }">
      <span *ngIf="hasScore" class="flex justify-center items-center text-lg font-semibold text-white tracking-wide h-full w-full cursor-default">{{ qualification?.score }}</span>
      <span *ngIf="!hasScore && !isRunning" class="flex justify-center items-center text-sm font-semibold text-white tracking-wide h-full w-full cursor-default">SQL</span>
    </div>

    <div class="w-full min-w-0 pl-2 2xl:pl-3">
      <p class="mx-auto text-sm text-secondary dark:text-white font-semibold w-full">
        SQL Score
        <span *ngIf="hasScore && tierLabel" class="font-normal text-xs text-gray-500 dark:text-gray-400">· {{ tierLabel }}</span>
      </p>
      <button type="button" class="text-left text-sm tracking-wide mt-1"
              [disabled]="state.starting"
              [ngClass]="{
                 'text-icp-low': hasScore && tierClass === 'low',
                 'text-icp-medium': hasScore && tierClass === 'medium',
                 'text-icp-high': hasScore && tierClass === 'high',
                 'text-[#802cfa]': !hasScore && !isRunning,
                 'text-gray-400 dark:text-gray-400': isRunning
              }"
              (click)="openWizard()">{{ subtitle }}</button>
    </div>

  </div>
</div>
